<template>
  <el-card class="container">
    <el-row>
      <el-col :span="12">
        <el-form :inline="true" :model="searchParams">
          <el-form-item>
            <el-input size="small" v-model="searchParams.name" placeholder="请输入角色名搜索"
              class="search-input" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">
              搜索
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :offset="8" :span="4">
        <el-button size="small" type="primary" class="float-right" icon="el-icon-plus" @click="addRole">
          新增角色</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" style="margin-top: 20px">
      <el-table-column prop="name" label="角色" width="120" header-align="center" align="center">
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述信息"
        width="250"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="app_names"
        label="Apps"
        style="text-align:center"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          <span v-for="app of scope.row.apps" :key="app.id" class="self-tag">
            {{ `${app.name}(${app.package_name})` }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteRole(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="roleList.length > 0"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="limit"
      style="float: right; margin: 20px 0"
      @current-change="changePage">
    </el-pagination>
    <el-dialog
      title="新增角色"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="roleForm" :rules="roleFormRules" :model="roleForm" label-width="120px">
        <el-form-item label="Name" prop="name">
          <el-input v-model="roleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="desc">
          <el-input v-model="roleForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="Apps" prop="apps">
          <el-select v-model="roleForm.apps" multiple style="width: 100%" filterable>
            <el-option v-for="app of apps" :key="app.id" :label="`${app.name}(${app.package_name})`" :value="app.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Pages" prop="page_ids">
          <div style="max-height: 300px; overflow: auto">
            <el-tree
              v-if="showTree"
              v-model="roleForm.page_ids"
              :data="treeData"
              show-checkbox
              node-key="id"
              :default-expand-all="true"
              :default-checked-keys="checkedPages"
              :props="defaultProps"
              ref="tree">
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>

  export default {
    data () {
      return {
        page: 1,
        limit: 12,
        searchParams: {
          name: ''
        },
        apps: [],
        pages: [],
        showTree: false,
        treeData: {},
        roleList: [],
        tableData: [],
        totalCount: 0,
        dialogVisible: false,
        roleForm: {},
        checkedPages: [],
        roleFormRules: {
          name: [
            { required: true, message: '请输入角色名', trigger: 'blur' },
          ],
        },
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    methods:{
      async getApps () {

        let url = `/etp/app/list`;
        let rst = await this.$http.get(url);

        this.apps = rst.data.data || [];

      },
      async getRoleList() {

        let url = '/ams/role/list';

        let searchName = this.searchParams.name.trim();
        if (searchName) {
          url = url + `?name=${searchName}`
        }

        let rst = await this.$http.get(url);
        let roleList = rst.data.data || [];
        roleList.forEach(role => {
          let apps = this.apps.filter((a) => (role.apps || []).indexOf(a.id) > -1 );

          let names = apps.map(a => a.name);
          let name = '';
          if (names.length > 10) {
            name = names.slice(0, 10).join(', ') + ' ...';
          } else {
            name = names.join(', ');
          }
          role.app_names = name;
          role.apps = apps;
        })

        this.roleList   = rst.data.data || [];
        this.totalCount = this.roleList.length;
        this.changePage(1);

      },
      buildPageTree(pages, currPage) {

        let tree  = {};
        tree.id     = currPage.id;
        tree.label  = currPage.system ? `${currPage.name}(${currPage.system})`: currPage.name ;

        let subPages = pages.filter((p) => p.parent_id == currPage.id);
        let children  = subPages.map((p) => this.buildPageTree(pages, p));

        tree.children = children;
        return tree;

      },
      async getPages () {

        let url = '/ams/page/list';
        let rst = await this.$http.get(url);

        let pages   = rst.data.data;
        this.pages  = pages;

        let tree = this.buildPageTree(pages, { id: 0, name: '所有权限' })
        this.treeData = tree.children;

      },
      search() {
        this.page = 1;
        this.getRoleList();
      },
      addRole() {
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys([]);
        }
        this.roleForm = {};
        this.dialogVisible = true;
        this.showTree = true;
      },

      async getRoleDetail(roleId) {
        let url = `/ams/role/detail?id=${roleId}`;
        let rst = await this.$http.get(url);
        return rst.data.data;
      },
      async edit(row) {
        this.showTree = false;
        let detail = await this.getRoleDetail(row.id);
        this.checkedPages = detail.pages.map(p => p.id);

        this.roleForm = detail;

        this.dialogVisible = true;
        this.showTree = true;
      },
      deleteRole(row) {
        this.$confirm(`确认删除${row.name}?`)
          .then(async () => {
            let rst = await this.$http.post('/ams/role/delete', { id: [row.id] });

            if (rst.data.err_code == 0) {
              this.$notify({
                title: '提示',
                message: '删除成功',
                type: 'success'
              })
            }

            this.getRoleList();

          })
          .catch(_ => {
            this.getRoleList();
          });
      },
      handleClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs['roleForm'].validate(async (valid) => {

          if (!valid) {
            this.$notify({
              title: "警告",
              message: "请输入必填信息",
              type: "warning"
            })
            return;
          }

          let checkedKeys = this.$refs.tree.getCheckedKeys();
          let pages = [];
          this.pages.forEach((p) => {

            if (checkedKeys.indexOf(p.id) == -1) {
              return
            }

            if (checkedKeys.indexOf(p.parent_id) > -1) {
              return
            }

            pages.push(p);

          })

          this.roleForm.pages = pages;

          let rst = await this.$http.post('/ams/role/save', JSON.stringify(this.roleForm));
          if (rst.data.err_code == 0) {
            this.$notify({
              title: '提示',
              message: '保存成功',
              type: 'success'
            })
            this.dialogVisible = false;
            this.getRoleList();
          }

        })

      },
      changePage(val) {
        this.page = val;
        this.tableData = this.roleList.slice((this.page - 1) * this.limit, this.page * this.limit);
      },
      app(data){
        this.selItem = JSON.parse(JSON.stringify(data))
        this.apps.length==0?this.getApp():null
        this.$http.get('/ams/role/detail',{params:{id:data.id}}).then(res=>{
            this.selItem = res.data.data;
            let apps = this.selItem.apps || [];

            this.appId = data.apps || [];
            this.showApp = true
        })
      },
      appSave(){
        let appIds = this.appId.filter(x => x);

        this.$http.post('/ams/role/app/save', {role_id: this.selItem.id, app_id: appIds}).then(()=>{
          this.showApp=false
          this.getList(true)
        });
      },
    },
    async mounted() {
      await this.getApps();
      await this.getRoleList();
      this.getPages();
    }
  }
</script>
<style lang="less" scoped>
.container {
  margin: 20px;
}
.self-tag {
  margin-left: 3px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  display: inline-block;
  height: 26px;
  padding: 0 10px;
  line-height: 26px;
  font-size: 12px;
  color: #409eff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
}
</style>
